import { DateTime, Interval } from 'luxon';

export const today = (): DateTime => {
    return DateTime.now().startOf('day');
}

export const todayJsDate = (): Date => today().toJSDate();

export const isSameOrBeforeToday = (dateValue: Date | string) => {
    const date = toDateTime(dateValue)
    const todayDate = today();
    return date <= todayDate;
}

export const isDateAfterDate = (sourceDate: Date | string, targetDate: Date | string) => {
    const source = toDateTime(sourceDate);
    const target = toDateTime(targetDate).endOf('day');

    return source > target;
}

export const isDateBeforeDate = (sourceDate: Date | string, targetDate: Date | string) => {
    const source = toDateTime(sourceDate);
    const target = toDateTime(targetDate).startOf('day');

    return source < target;
}

export const isDateSame = (sourceDate: Date | string | null, targetDate: Date | string | null) => {
    if (!sourceDate || !targetDate) return false;

    const source = toDateTime(sourceDate);
    const target = toDateTime(targetDate);

    return source.hasSame(target, 'day');
}

// Contains only compare with date only and ignore the time.
export const dateContains = (startDate: Date | string | null, endDate: Date | string | null, targetDate: Date | string | null) => {
    if (!startDate || !endDate || !targetDate) return false;

    const start = toDateTime(startDate).startOf('day');
    const end = toDateTime(endDate).endOf('day');
    const target = toDateTime(targetDate);

    const range = Interval.fromDateTimes(start, end);

    return range.contains(target);
}

export const setToNewZealandTimeZone = (dateValue: Date | string) => {
    let date = new Date(dateValue);
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));
    const nzDate = DateTime.fromISO(date.toISOString().split('Z')[0], { zone: 'Pacific/Auckland' });
    return nzDate.toJSDate();
}

export const toNewZealandDateString = (date: Date | string | null, format: string = 'dd/MM/yyyy') => {
    if (!date) return '-';

    let dt = toDateTime(date);
    dt = dt.setZone('Pacific/Auckland');
    return dt.toFormat(format);
}

export const toDateTime = (date: Date | string): DateTime => {
    return typeof date === 'string' ? DateTime.fromISO(date) : DateTime.fromJSDate(date);
}

export const addDays = (date: Date, days: number): Date => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};